<template>
  <div class="view-container">
    <div class="flex flex-col justify-around items-center">
      <div class="max-w-md w-full md:w-1/2 flex flex-wrap content-center justify-center">
        <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid }">
          <form @submit.prevent="submit()">

            <ValidationProvider :vid="$t('config.annual_leave_quantity')">
              <div class="flex w-full  mt-2 h-12 items-center">
                <label class="flex-grow vs-input--label mr-2">{{
                  $t('config.annual_leave_quantity') }}</label>
                <vs-input class=" pl-2 w-20 flex-shrink-0" min="0"
                          type="number"
                          v-model="configs.annual_leave_quantity"/>
              </div>
            </ValidationProvider>

            <div class="flex w-full  mt-2 h-12 items-center">
              <label class="flex-grow vs-input--label mr-2">
                {{ $t('config.should_postpone_holidays') }}
              </label>
              <toggle-button :height="25"
                             :sync="true"
                             :width="62"
                             v-model="configs.should_postpone_holidays"/>
            </div>

            <ValidationProvider :vid="$t('config.should_get_holidays_from_working_day_overtime')">
              <div class="flex w-full  mt-2 h-12 items-center">
                <label class="flex-grow vs-input--label mr-2">
                  {{ $t('config.should_get_holidays_from_working_day_overtime') }}
                </label>
                <toggle-button :height="25"
                               :sync="true"
                               :width="62"
                               v-model="configs.should_get_holidays_from_working_day_overtime"/>
              </div>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.holidays_percentage_from_working_day_overtime')"
                                :rules="`required_if:${$t('config.should_get_holidays_from_working_day_overtime')},true|numeric`"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{
                  $t('config.holidays_percentage_from_working_day_overtime') }}</label>
                <vs-input :disabled="!configs.should_get_holidays_from_working_day_overtime" class=" pl-2 w-20 flex-shrink-0"
                          min="0"
                          type="number"
                          v-model="configs.holidays_percentage_from_working_day_overtime"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :vid="$t('config.should_get_holidays_from_non_working_day_overtime')">
              <div class="flex w-full  mt-2 h-12 items-center">
                <label class="flex-grow vs-input--label mr-2">{{
                  $t('config.should_get_holidays_from_non_working_day_overtime') }}</label>
                <toggle-button :height="25"
                               :sync="true"
                               :width="62" v-model="configs.should_get_holidays_from_non_working_day_overtime"/>
              </div>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.holidays_percentage_from_non_working_day_overtime')"
                                :rules="`required_if:${$t('config.should_get_holidays_from_non_working_day_overtime')},true|numeric`"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{
                  $t('config.holidays_percentage_from_non_working_day_overtime') }}</label>
                <vs-input :disabled="!configs.should_get_holidays_from_non_working_day_overtime" class=" pl-2 w-20 flex-shrink-0"
                          min="0"
                          type="number"
                          v-model="configs.holidays_percentage_from_non_working_day_overtime"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.expected_daily_working_hours')"
                                rules="required|numeric"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{
                  $t('config.expected_daily_working_hours') }}</label>
                <vs-input class=" pl-2 w-20 flex-shrink-0" min="0"
                          type="number"
                          v-model="configs.expected_daily_working_hours"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.overtime_percentage_on_working_day')"
                                rules="required|numeric"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{
                  $t('config.overtime_percentage_on_working_day') }}</label>
                <vs-input class=" pl-2 w-20 flex-shrink-0" min="0" type="number"
                          v-model="configs.overtime_percentage_on_working_day">/
                </vs-input>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.overtime_percentage_on_non_working_day')"
                                rules="required|numeric"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{
                  $t('config.overtime_percentage_on_non_working_day') }}</label>
                <vs-input class=" pl-2 w-20 flex-shrink-0" min="0" type="number"
                          v-model="configs.overtime_percentage_on_non_working_day"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.out_sick_percentage')"
                                rules="required|numeric"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{ $t('config.out_sick_percentage')
                  }}</label>
                <vs-input class=" pl-2 w-20 flex-shrink-0" min="0" type="number"
                          v-model="configs.out_sick_percentage"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.overtime_percentage_on_working_day')"
                                rules="required|numeric"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="flex-grow vs-input--label mr-2  self-center">{{
                  $t('config.holidays_validity_in_months') }}</label>
                <vs-input class=" pl-2 w-20 flex-shrink-0" min="0" type="number"
                          v-model="configs.holidays_validity_in_months"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider :name="$t('config.valid_from')"
                                rules="required"
                                v-slot="{ errors }">
              <div class="flex w-full  mt-2">
                <label class="w-3/4 vs-input--label mr-2  self-center">{{ $t('config.valid_from') }}</label>
                <date-picker class=" -mx-2" v-model="configs.valid_from"/>
              </div>
              <span class="text-xs italic text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>

            <div class="flex w-full mt-2">
              <label class="w-3/4 vs-input--label mr-2  self-center">{{ $t('config.valid_to') }}</label>
              <date-picker class=" -mx-2" ref="calendarTo" v-model="configs.valid_to"/>
            </div>
            <base-button :loading="loading" button="filled" class="w-full mx-2 my-5" color="success" type="submit">
              {{ $t('buttons.save') }}
            </base-button>

          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import DatePicker from "../../components/DatePicker";

  export default {
    name: "ConfigsComponent",
    components: {
      DatePicker
    },
    props: {
      configs: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      async submit () {
        const isValid = await this.$refs.validator.validate();
        if (!isValid) return
        this.$emit('confirm')
      },
    },
  }
</script>

<style scoped>

</style>
